import { sanitizeMarketDetailQuery } from '@/domain/market/market-detail-symbols.js';

/**
 * 体育赛事详情路由（对阵类；无主客队体育走通用 MarketDetail）。
 * @param {{ id?: string, query?: Record<string, string> }} [opts]
 * @returns {{ name: string, params: { matchId: string }, query?: Record<string, string> } | null}
 */
export function buildSportLiveMatchDetailRoute({ id = '', query = null } = {}) {
  const matchId = String(id ?? '').trim();
  if (!matchId) return null;

  const route = {
    name: 'SportLiveMatchDetail',
    params: { matchId },
  };
  const sanitized = sanitizeMarketDetailQuery(query && typeof query === 'object' ? query : {});
  if (sanitized) {
    const next = { ...sanitized };
    delete next.resolve;
    if (Object.keys(next).length) route.query = next;
  }
  return route;
}

/** 详情路由上的 collection / match id（体育 params.matchId，其余 params.id） */
export function resolveChannelDetailEntityId(route) {
  return String(route?.params?.matchId ?? route?.params?.id ?? '').trim();
}
